import { uniq } from 'es-toolkit';
import React, { FunctionComponent } from 'react';

import { closeCurrentPopup } from '@paragon/popup-state';

import { deleteBearing, deleteJackGirderConnections } from '../../store/actions/deletionActions';
import { CarriedBearingDeleteConfirmationProps } from '../../store/actions/popupActions';
import { useAppDispatch, useAppSelector } from '../hooks';
import { ConfirmDialog } from './ConfirmDialog';

export const CarriedBearingDeleteConfirmDialog: FunctionComponent<CarriedBearingDeleteConfirmationProps> = ({
  componentDesign,
  bearing,
}) => {
  const dispatch = useAppDispatch();
  const jackGirderConnections = useAppSelector((state) => state.jackGirderConnections.data);
  const relatedCarriedComponentConnections = Object.values(jackGirderConnections).filter(
    ({ jackBearingGuid }) => jackBearingGuid === bearing.guid,
  );
  const allComponentDesigns = useAppSelector((state) => state.componentDesigns.data);
  const carryingComponentNames = uniq(
    relatedCarriedComponentConnections
      .map((connection) => allComponentDesigns[connection.girderGuid])
      .map((componentDesign) => componentDesign?.component.name ?? 'unknown'),
  );

  return (
    <ConfirmDialog
      open
      title="Confirm Delete"
      message={`This bearing is carried by: ${carryingComponentNames.join(
        ', ',
      )}. If you delete it, the carried component connection(s) will be deleted as well.`}
      onClose={async (confirmed) => {
        dispatch(closeCurrentPopup());
        if (confirmed) {
          await dispatch(deleteJackGirderConnections(relatedCarriedComponentConnections));
          dispatch(deleteBearing(componentDesign, bearing));
        }
      }}
    />
  );
};
